import { ReactComponent as EthereumLogo } from './ethereum-logo.svg';
import { ReactComponent as LinkdropLogo } from './linkdrop-logo.svg';
import { ReactComponent as LinkdropWhiteLogo } from './linkdrop-white-logo.svg';
import { ReactComponent as LinkdropTextLogo } from './linkdrop-text-logo.svg';
import { ReactComponent as DashboardMenuIcon } from './dashboard-menu-icon.svg';
import { ReactComponent as SupportMenuIcon } from './support-menu-icon.svg';
import { ReactComponent as FaqMenuIcon } from './faq-menu-icon.svg';
import { ReactComponent as DocsMenuIcon } from './docs-menu-icon.svg';
import { ReactComponent as StarMenuIcon } from './star-menu-icon.svg';
import { ReactComponent as GoBackIcon } from './go-back-icon.svg';
import { ReactComponent as DownloadIcon } from './download-icon.svg'
import { ReactComponent as ExternalLinkIcon } from './external-link-icon.svg'
import { ReactComponent as ArrowIcon } from './arrow-icon.svg'
import { ReactComponent as CloseIcon } from './close-icon.svg'
import { ReactComponent as CheckboxIcon } from './checkbox-icon.svg'

const Icons = {
  EthereumLogo,
  LinkdropLogo,
  LinkdropTextLogo,
  DashboardMenuIcon,
  SupportMenuIcon,
  FaqMenuIcon,
  DocsMenuIcon,
  StarMenuIcon,
  LinkdropWhiteLogo,
  GoBackIcon,
  DownloadIcon,
  ExternalLinkIcon,
  ArrowIcon,
  CloseIcon,
  CheckboxIcon
}

export default Icons
